module.exports = __webpack_public_path__ + "img/2.48ac620d.jpg";